export const getSalesViewStorageKey = (accountNumber: string): string => {
    if (typeof window === 'undefined' || !accountNumber) {
        return '';
    }

    return `ab_salesView_${accountNumber}`;
};
